<div>
    <rwidget-alert></rwidget-alert>
    <div
        class="sr-app-light:visible vl-app-light:visible border-b border-solid border-opacity-10 bg-[var(--color-panel)] py-2 md:hidden">
        <div class="flex flex-row items-center justify-between">
            <ion-button
                [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                (click)="handleBackClicked()"
                color="secondary"
                fill="clear">
                <ion-icon
                    class="mr-1 text-xl dark:filter-yellow"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg">
                </ion-icon>
            </ion-button>
            <h1 class="text-base font-bold leading-5">
                {{ 'NOTIFICATION_SETTINGS_SIDE_TITLE' | translate }}
            </h1>
            <div class="w-12"></div>
        </div>
    </div>

    <div class="p4 mx-auto mt-4 max-w-md space-y-6 sm:mt-4" *ngIf="env.ACCOUNT.SHOW_NEW_NOTIFICATION_SETTINGS">
        <ng-container *ngFor="let notificationPreference of notificationPreferencesView | keyvalue: preserveOrder">
            <div class="rounded-lg bg-[var(--color-panel)]">
                <div
                    class="mx-4 flex items-center justify-between py-4 pr-4 sm:pr-6"
                    *ngIf="
                        notificationPreference.key === NotificationPreferenceChannel.Push &&
                        this.env.APP_NOTIFICATIONS?.SHOW_REDIRECT_TO_OS_SETTINGS
                    ">
                    <span class="notification-settings-heading ml-1 text-sm font-bold uppercase leading-5 sm:ml-2">
                        {{ 'NOTIFICATION_PREFERENCES_CHANNEL_' + (notificationPreference.key | uppercase) | translate }}
                    </span>
                    <button
                        class="cursor-pointer"
                        [attr.aria-label]="'NOTIFICATION_PREFERENCES_CHANNEL_PUSH_NOTIFICATION' | translate"
                        (click)="openOsNotificationSettings()"
                        role="button">
                        <ion-icon
                            class="text-[1.5rem] text-black dark:text-contrast-yellow"
                            name="open-outline"
                            aria-hidden="true"></ion-icon>
                    </button>
                </div>
                <div
                    class="mx-4 py-4 pr-4 sm:pr-6"
                    *ngIf="
                        !(
                            notificationPreference.key === NotificationPreferenceChannel.Push &&
                            this.env.APP_NOTIFICATIONS?.SHOW_REDIRECT_TO_OS_SETTINGS
                        )
                    ">
                    <button
                        class="flex w-full cursor-pointer items-center justify-between"
                        [attr.aria-checked]="getChannelEnabled(notificationPreference.key)"
                        [attr.aria-label]="
                            'NOTIFICATION_PREFERENCES_CHANNEL_' + (notificationPreference.key | uppercase) | translate
                        "
                        (click)="
                            onChannelToggle(notificationPreference.key, !getChannelEnabled(notificationPreference.key))
                        "
                        role="switch">
                        <span
                            class="notification-settings-heading ml-1 text-sm font-bold uppercase leading-5 sm:ml-2"
                            aria-hidden="true">
                            {{
                                'NOTIFICATION_PREFERENCES_CHANNEL_' + (notificationPreference.key | uppercase)
                                    | translate
                            }}
                        </span>
                        <mat-slide-toggle
                            class="toggle-slide pointer-events-none mr-1 sm:mr-2"
                            [checked]="getChannelEnabled(notificationPreference.key)"
                            aria-hidden="true"
                            tabindex="-1">
                        </mat-slide-toggle>
                    </button>
                </div>

                <div class="mx-4 pb-4" *ngIf="notificationPreference.value?.length">
                    <div class="mx-1 rounded-lg bg-gray-100 py-2 pl-4 pr-4 dark:bg-transparent sm:mx-2 sm:pl-6 sm:pr-6">
                        <button
                            class="mb-2 flex w-full cursor-pointer items-center justify-between py-2"
                            *ngFor="let setting of notificationPreference.value"
                            [attr.aria-checked]="getSettingValue(notificationPreference.key, setting)"
                            [attr.aria-label]="'NOTIFICATION_PREFERENCE_' + (setting | uppercase) | translate"
                            (click)="
                                onChannelSettingToggle(
                                    notificationPreference.key,
                                    setting,
                                    !getSettingValue(notificationPreference.key, setting)
                                )
                            "
                            type="button"
                            role="switch">
                            <span class="text-base" aria-hidden="true">
                                {{ 'NOTIFICATION_PREFERENCE_' + (setting | uppercase) | translate }}
                            </span>
                            <mat-slide-toggle
                                class="toggle-slide pointer-events-none mr-0"
                                [checked]="getSettingValue(notificationPreference.key, setting)"
                                aria-hidden="true"
                                tabindex="-1">
                            </mat-slide-toggle>
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

        <div
            class="flex cursor-pointer items-center justify-between rounded-lg bg-[var(--color-panel)] px-4 py-4"
            *ngIf="
                env.DISRUPTION_SUBSCRIPTIONS?.SHOW_SUBSCRIBED_NOTIFICATIONS_BUTTON && {
                    count: subscribedNotificationsCount$ | async
                } as data
            "
            [routerLink]="(data.count > 0 ? '/account/edit-subscriptions' : '/account/add-subscriptions') | localize"
            routerLinkActive="router-link-active">
            <span class="text-base font-semibold">
                {{ 'NOTIFICATION_SETTINGS_SUBSCRIBED_NOTIFICATIONS' | translate }}
            </span>
            <div class="flex items-center gap-2">
                <span class="text-base text-gray-600 dark:text-contrast-yellow">
                    {{ data.count }}
                </span>
                <ion-icon
                    class="text-xl text-gray-400 dark:text-contrast-yellow"
                    name="chevron-forward"
                    aria-hidden="true"></ion-icon>
            </div>
        </div>
        <rwidget-add-email-modal #emailModal></rwidget-add-email-modal>
    </div>
</div>
